
import React from 'react';

const MetricAnimations: React.FC = () => {
  return (
    <style>
      {`
      @keyframes rainbowPulse {
        0% { opacity: 0.9; }
        50% { opacity: 1; }
        100% { opacity: 0.9; }
      }
      
      .rainbow-pulse-effect {
        animation: rainbowPulse 2s infinite linear;
      }
      
      @keyframes pulseRed {
        0% { opacity: 0.7; }
        50% { opacity: 1; }
        100% { opacity: 0.7; }
      }
      
      .pulse-red-effect {
        animation: pulseRed 1s infinite;
      }
      `}
    </style>
  );
};

export default MetricAnimations;
